module.exports = __webpack_public_path__ + "img/PlusIcon.ef5b8ad0.svg";